module.exports = __webpack_public_path__ + "img/11400.af092691.jpg";